"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffPartnerScanPayModel = instanceOfLiffPartnerScanPayModel;
exports.LiffPartnerScanPayModelFromJSON = LiffPartnerScanPayModelFromJSON;
exports.LiffPartnerScanPayModelFromJSONTyped = LiffPartnerScanPayModelFromJSONTyped;
exports.LiffPartnerScanPayModelToJSON = LiffPartnerScanPayModelToJSON;
exports.LiffPartnerScanPayModelToJSONTyped = LiffPartnerScanPayModelToJSONTyped;
/**
 * Check if a given object implements the LiffPartnerScanPayModel interface.
 */
function instanceOfLiffPartnerScanPayModel(value) {
    return true;
}
function LiffPartnerScanPayModelFromJSON(json) {
    return LiffPartnerScanPayModelFromJSONTyped(json, false);
}
function LiffPartnerScanPayModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'qrData': json['qrData'] == null ? undefined : json['qrData'],
        'partnerOrgId': json['partnerOrgId'] == null ? undefined : json['partnerOrgId'],
        'partnerName': json['partnerName'] == null ? undefined : json['partnerName'],
    };
}
function LiffPartnerScanPayModelToJSON(json) {
    return LiffPartnerScanPayModelToJSONTyped(json, false);
}
function LiffPartnerScanPayModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'qrData': value['qrData'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
    };
}
